export default __webpack_public_path__ + "static/media/DemarrSneaker.bcc92318.jpg";